import axios from 'axios';
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { CrmEditInvoiceForm } from './CrmEditInvoiceForm';
import CrmEditInvoiceTable from './CrmEditInvoiceTable';
import { CrmEditInvoiceBill } from './CrmEditInvoiceBill';
import { useSnackbar } from '../../../context/SnackBarContext';
import fetcher from '../../../helper/fetcher';
import { apiUrl } from '../../../utils/utils';

const CrmEditInvoice = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const invoiceData = location.state?.data   // invoice object passed via navigation
    
    console.log("invoiceData ===>>", invoiceData)
    const { showSuccess, showError } = useSnackbar();
    const [state, setState] = useState({
        isModalOpen: false,
        selectedContact: null,
        isDrawerOpen: false,
        isContactDrawerOpen: false,
        isProductDrawerOpen: false,
        availableUser: [],
        isLoading: false,
        searchQuery: '',
        memo: '',
    })
    const [modalOpen, setModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        invoiceDate: "",
        paymentStatus: "",
        paymentDate: "",
        salesPersonContactNo: "",
        shippingDate: "",
        salesPerson: "",
        paymentMode: "",
        withGst: true,
        customerName: "",
        gst: "",
        billAddress: "",
        shipingAddress: "",
        customerPhone: "",
        state: "",
        trackingId: ""
    });

    const [tableData, setTableData] = useState([]);
    const [billingData, setBillingData] = useState({
        subTotal: "0.00",
        totalDiscount: '0.00',
        beforeTax: '0.00',
        tax: '0.00',
        tcs: '0.00',
        roundOff: '0',
        total: '0.00',
    })

    const updateState = (data) => {
        setState((prevState) => ({ ...prevState, ...data }))
    }

    //  Prefill when editing
    useEffect(() => {
        if (invoiceData) {
            setFormData({
                invoiceDate: invoiceData.invoiceDate?.split("T")[0] || "",
                paymentStatus: invoiceData.paymentStatus || "",
                paymentDate: invoiceData.paymentDate?.split("T")[0] || "",
                salesPersonContactNo: invoiceData.salesPersonContactNo || "",
                shippingDate: invoiceData.shippingDate?.split("T")[0] || "",
                salesPerson: invoiceData.salesPerson || "",
                paymentMode: invoiceData.paymentMode || "",
                withGst: invoiceData.withGst,
                customerName: invoiceData.customerName || "",
                gst: invoiceData.gst || "",
                billAddress: invoiceData.billAddress || "",
                shipingAddress: invoiceData.shipingAddress || "",
                customerPhone: invoiceData.customerPhone || "",
                state: invoiceData.state || "",
                trackingId: invoiceData.trackingId || ""
            });

            setTableData(invoiceData.product || []);   // already array on backend
            setBillingData({
                subTotal: invoiceData.subTotal || "0.00",
                totalDiscount: invoiceData.totalDiscount || "0.00",
                beforeTax: invoiceData.beforeTax || "0.00",
                tax: invoiceData.tax || "0.00",
                tcs: invoiceData.tcs || "0.00",
                roundOff: invoiceData.roundOff || "0",
                total: invoiceData.total || "0.00",
            });
            updateState({ memo: invoiceData.memo || "" })
        }
    }, [invoiceData]);

    // ✅ Save Edited Invoice
    const handleUpdateCrmInvoice = () => {
        const payload = {
            invoiceDate: formData.invoiceDate,
            paymentStatus: formData.paymentStatus,
            shippingDate: formData.shippingDate,
            paymentDate: formData.paymentDate,
            salesPersonContactNo: formData.salesPersonContactNo,
            trackingId: formData.trackingId,
            paymentMode: formData.paymentMode,
            salesPerson: formData.salesPerson,

            gst: formData.gst,
            billAddress: formData.billAddress,
            shipingAddress: formData.shipingAddress,
            customerName: formData.customerName,
            customerPhone: formData.customerPhone,
            withGst: formData.withGst,
            state: formData.state,

            total: billingData.total,
            subTotal: billingData.subTotal,
            totalDiscount: billingData.totalDiscount,
            tax: billingData.tax,
            memo: state.memo,

            product: tableData.map(item => ({
                productId: item.productId?._id,
                igst: item.igst || null,
                cgst: item.cgst || null,
                sgst: item.sgst || null,
                quantity: item.quantity,
                price: item.price,
                discount: item.discount,
                amount: item.amount,
                unit:item.unit,
            }))
        };

        if (!billingData.subTotal) {
            return showError("Subtotal is Required");
        }

        updateState({ isLoading: true });
        fetcher.patch(`${apiUrl}crm/invoice/update_invoice_by_id/${invoiceData?._id}`, payload)
            .then(() => {
                showSuccess("Invoice Updated successfully");
                setTimeout(() => {
                    navigate("/crm/manage-invoice");
                }, 1000);
            })
            .catch((error) => {
                showError(error?.response?.data?.message || "Something went wrong");
                console.error("Update error:", error);
            })
            .finally(() => {
                updateState({ isLoading: false });
                setTimeout(() => setModalOpen(false), 500);
            });
    };

    return (
        <div className='bg-white rounded-lg pb-12'>
            <CrmEditInvoiceForm
                state={state}
                updateFunc={updateState}
                formData={formData}
                handleSaveCrmInvoice={handleUpdateCrmInvoice}  // ✅ changed to update
                setFormData={setFormData}
                billingData={billingData}
                setModalOpen={setModalOpen}
                tableData={tableData}
                modalOpen={modalOpen}
            />
            <CrmEditInvoiceTable
                setBillingData={setBillingData}
                state={state}
                setTableData={setTableData}
                updateFunc={updateState}
                tableData={tableData}
                formData={formData}
            />
            <CrmEditInvoiceBill
                state={state}
                updateFunc={updateState}
                billingData={billingData}
                formData={formData}
            />
        </div>
    )
}

export default CrmEditInvoice
